<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 15px;">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营单维护</el-breadcrumb-item>
      <el-breadcrumb-item>运营单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px " @clear="getyunyingList" @change="getyunyingList">
            <el-button slot="append" icon="el-icon-search" @click="getyunyingList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="10">
          <el-button type="primary" @click="get_yunying_add" v-if="false">添加运营单</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="yunyingList" style="width: 100%" byunying stripe id="report">
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="yy_bianhao" label="编号"></el-table-column>
            <el-table-column prop="paizhao" label="牌照"></el-table-column>
            <el-table-column prop="pro_count" label="数量"></el-table-column>
            <el-table-column prop="yy_money" label="项目总价"></el-table-column>
            <el-table-column label="车型" v-if="xiugai_type === 1" width="350">
              <template v-slot="scope"> <span>{{ scope.row.chexing01 }}: {{ scope.row.chexing02 }}:{{
        scope.row.chexing03
      }}:{{ scope.row.chexing04 }}</span></template>
            </el-table-column>
            <el-table-column prop="pro_name" label="项目"></el-table-column>

            <el-table-column prop="yy_on_time" label="开始时间"></el-table-column>
            <el-table-column prop="yy_off_time" label="结束时间"></el-table-column>

            <el-table-column prop="mac_bianhao" label="客户信息">
              <template v-slot="scope"> <span>{{ scope.row.guest_bianhao }}: {{ scope.row.guest_name }}:
                  {{ scope.row.guest_mob }}</span></template>
            </el-table-column>
            <el-table-column prop="mac_bianhao" label="指派员工信息">
              <template v-slot="scope"> <span>{{ scope.row.yuangong_bianhao }}: {{ scope.row.yuangong_name }}:
                  {{ scope.row.yuangong_mob }}</span></template>
            </el-table-column>
            <el-table-column prop="mac_bianhao" label="当前状态">
              <template v-slot="scope"> <span> {{ scope.row.status_flag === 1 ? '未开始' : '' }}{{ scope.row.status_flag
        ===
        2 ?
        '正在进行' : '' }}{{ scope.row.status_flag === 3 ? '服务结束' : '' }}</span></template>
            </el-table-column>
            <el-table-column prop="mac_bianhao" label="质检状态">
              <template v-slot="scope"> <span> {{ scope.row.zhijian_status === 1 ? '不合格' : '' }}{{
        scope.row.zhijian_status === 2 ?
          '需整改' : '' }}{{ scope.row.zhijian_status === 3 ? '合格' : '' }}</span></template>
            </el-table-column>
            <el-table-column label="操作" v-if="xiugai_type === 1" min-width="300">
              <template v-slot="scope">
                <el-tooltip class="button_pz" effect="dark" content="分配员工" :enterable="false"
                  v-if="scope.row.zhijian_status !== 3">
                  <el-button type="primary" icon="el-icon-edit"
                    @click="showFenpeiDialog(scope.row.uid)">分配员工</el-button>
                </el-tooltip>
                <el-tooltip class="button_pz" content="质检确认" :enterable="false" v-if="scope.row.status_flag > 1">
                  <el-button type="primary" icon="el-icon-edit"
                    @click="showZhijianDialog(scope.row.uid)">质检确认</el-button>
                </el-tooltip>
                <el-tooltip class="button_pz" content="施工单" :enterable="false" v-if="scope.row.status_flag > 1">
                  <el-button type="primary" icon="el-icon-edit"
                    @click="showShigongdanDialog(scope.$index)">施工单</el-button>
                </el-tooltip>

                <el-tooltip class="button_pz" effect="dark" content="删除" placement="top" :enterable="false"
                  v-if="false">
                  <el-button type="danger" icon="el-icon-delete" circle size="mini"
                    @click="deleteForm(scope.row.uid)"></el-button>
                </el-tooltip>
                <el-tooltip class="button_pz" effect="dark" content="运营单回访" placement="top" :enterable="false"
                  style="display: none;" v-if="false">
                  <el-button type="success" icon="el-icon-orange" @click="showHuifangDialog(scope.row.uid)" circle
                    size="mini"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 运营单回访窗口 -->

      <el-dialog title="运营单回访" :visible.sync="huifangDialogVisible" width="50%" @close="huifangDoalogClosed">

      </el-dialog>
      <!-- 添加运营单部分 -->
      <el-dialog title="添加运营单" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">

      </el-dialog>
      <!-- 分配员工 -->
      <el-dialog title="分配员工" :visible.sync="editDialogVisible" width="50%" @close="editDoalogClosed">
        <el-form ref="editFormRef" :model="editFormYuangong" :rules="addFormRules" label-width="100px">

          <el-form-item label="请选择员工" prop="yunying_level">
            <el-select v-model="editFormYuangong.yuangong_uid">
              <el-option v-for="item in yuangong_options" :key="item.uid"
                :label="item.yuangong_name + String.fromCharCode(58) + item.yuangong_mob" :value="item.uid"></el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateyunying">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 质量检测 -->
      <el-dialog title="质检确认" :visible.sync="zhijianDialogVisible" width="50%" @close="editDoalogClosed">
        <el-form ref="editFormRef" :model="editFormYuangong" :rules="addFormRules" label-width="100px">

          <el-form-item label="质检结果" prop="yunying_level">
            <el-select v-model="editFormZhijian.zhijian_status">
              <el-option v-for="item in zhijian_options" :key="item.uid" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="zhijianDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateZhijian">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="施工单" :visible.sync="shigongdanDialogVisible" width="50%" @close="shigongDoalogClosed">
        <div id="printMe">
          <div class="title"> {{ qiyeName }}施工单 </div>
          <div class="shigongdan">

            <div class="shigongdan_hang01">

              <div class="xiangmu01">
                <div class="name01">车主姓名：</div>
                <div class="data01">{{ yunyingInfoNow.guest_name }}</div>
              </div>
              <div class="xiangmu01">
                <div class="name01">客户姓名：</div>
                <div class="data01">{{ yunyingInfoNow.guest_bianhao }}</div>
              </div>
              <div class="xiangmu01">
                <div class="name01">公里数：</div>
                <div class="data01">{{ yunyingInfoNow.gonglishu }}</div>
              </div>
            </div>
            <div class="shigongdan_hang01">
              <div class="xiangmu01">
                <div class="name01">车牌：</div>
                <div class="data01">{{ yunyingInfoNow.paizhao }}</div>
              </div>
              <div class="xiangmu01">
                <div class="name01">服务顾问：</div>
                <div class="data01">{{ yunyingInfoNow.jiedai_yuangong_bianhao }}:{{ yunyingInfoNow.jiedai_yuangong_name
                  }}
                </div>
              </div>
              <div class="xiangmu01">
                <div class="name01">进厂时间：</div>
                <div class="data01">{{ yunyingInfoNow.order_add_time }}</div>
              </div>
            </div>
            <div class="shigongdan_hang01">
              <div class="xiangmu01">
                <div class="name01">施工：</div>
                <div class="data01">{{ yunyingInfoNow.shigong_yuangong_bianhao }}:{{ yunyingInfoNow.shigong_yuangong_name }}</div>
              </div>
              <div class="xiangmu01">
                <div class="name01"> </div>
                <div class="data01"> 
                </div>
              </div>
              <div class="xiangmu01">
                <div class="name01"> </div>
                <div class="data01"></div>
              </div>
            </div>
            <div class="shigongdan_hang01">
              <div class="xiangmu01">
                <div class="name01">服务项目：</div>
                <div class="data01"> </div>
              </div>
              <div class="xiangmu01">
                <div class="name01"> </div>
                <div class="data01">
                </div>
              </div>
              <div class="xiangmu01">
                <div class="name01"> </div>
                <div class="data01"> </div>
              </div>
            </div>
            <div class="print-only" style="margin-top: 0px;">----------------------------------------------------------------------------------------------</div> 
            <div class="shigongdan_hang01">
              <div class="name01"> </div>
              <div class="data01"> 商品编号</div>
              <div class="data01"> 名称</div>
              <div class="data01"> 数量</div>
              <div class="data01"> 市场价格</div>
              <div class="data02" style="width: 300px;"> 订单时间</div>
            </div>
            <div class="shigongdan_hang01">
              <div class="name01"> </div>
              <div class="data01"> {{ yunyingInfoNow.pro_bianhao }}</div>
              <div class="data01"> {{ yunyingInfoNow.pro_name }}</div>
              <div class="data01"> {{ yunyingInfoNow.pro_count }}</div>
              <div class="data01"> {{ yunyingInfoNow.pro_price_shichang }}</div>
              <div class="data02" style="width: 300px;"> {{ yunyingInfoNow.order_add_time }}</div>
            </div>
            <div style="background-color: black; height: 1px;" class="xian"></div>
            <div class="shigongdan_hang01">
              <div class="name01"> </div>
              <div class="data01"> </div>
              <div class="data01"> </div>
              <div class="data01"> </div>
              
            </div>
          </div>
          <div   style="margin-top: 50px;" class="print-only">
          ----------------------------------------------------------------------------------------------</div>

        <div  class="print-only">{{ qiyeName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话：{{
          userPhone }}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;打印日期：{{ nowDate }}&nbsp;&nbsp;{{ nowTime }} &nbsp;&nbsp;&nbsp;&nbsp;客户签字   </div>
          
        </div>
        
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="printPage">打印</el-button>
        </span>
      </el-dialog>

    </el-card>
  </div>
</template>
<script>
import printJS from 'print-js'
import { checkMobileTest, checkSfzId } from './config/validator'
import exportExcel from './config/exportExcel'
export default {
  props: ['xiugai_type', 'qiye_uid', 'show_type'], // xiugai_type 1  操作  2 显示 qiye_uid qiye_uid  企业uid ，显示模式show_type 全部显示，只显示指定企业uid部分
  data() {
    return {
      userPhone: '',
      qiyeName: '',
      nowDate: new Date().toLocaleDateString('zh-CN'),
      nowTime: new Date().toLocaleTimeString('zh-CN'),
      yuangong_options: [],
      zhijian_options: [
        {
          value: 1,
          label: '不合格'
        },
        {
          value: 2,
          label: '需要整改'
        },
        {
          value: 3,
          label: '合格'
        }
      ],
      yunyingLy_options: [
        {
          value: 1,
          label: '运营单介绍'
        },
        {
          value: 2,
          label: '回访运营单'
        },
        {
          value: 3,
          label: '上门运营单'
        }
      ],
      yunying_options: [
        {
          value: 1,
          label: '初级运营单'
        },
        {
          value: 2,
          label: '中级运营单'
        },
        {
          value: 3,
          label: '高级运营单'
        }
      ],
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list_more',
        C_table_name: 'yunying_list_more',
        query: '',
        pageNum: 1,
        pageSize: 10,
        CI_canshu01: this.show_type,
        CI_canshu02: 0
      },
      zhijianDialogVisible: false,
      huifang_isDisable: false,
      add_isDisable: false,
      yunyingList: [],
      yunyingInfoNow: {},
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      huifangDialogVisible: false,
      shigongdanDialogVisible: false,
      // 用于设置回访页面滑块值
      //  添加表单数据项
      huifangForm: {
        C_type: 'huifang_add',
        huifang_yunying_uid: 0,
        huifang_title: '',
        hufiang_memo: '',
        huifang_genjin: 1,
        huifang_yuangong_uid: 0,
        huifang_switch: true
      },
      addForm: {
        C_type: 'yunying_add',
        yunying_bianhao: '',
        yunying_name: '',
        yunying_mob: '11111111111',
        yunying_addr: '',
        yunying_sfz_bianhao: '111111111111111111',
        yunying_level: 1,
        yunying_price_want: 0,
        yunying_yixiang: '',
        yunying_memo: '',
        yunying_laiyuan: 1
      },
      // 用于修改数据绑定
      editForm: {},
      editFormZhijian: {
        C_type: 'yunying_zhijian_update',
        yunying_uid: 0,
        zhijian_status: 3
      },
      editFormYuangong: {
        C_type: 'yunying_yuangong_update',
        yunying_uid: 0,
        yuangong_uid: 0
      },
      // 表单规则项
      addFormRules: {
        yunying_name: [
          { required: true, message: '请输入运营单名称', trigger: 'blur' },
          { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
        ],
        yunying_mob: [
          {
            validator: checkMobileTest.bind(
              this.addForm && this.addForm.yunying_mob
            )
          }
        ],
        yunying_sfz_bianhao: [
          {
            validator: checkSfzId.bind(
              this.addForm && this.addForm.yunying_sfz_bianhao
            )
          }
        ]
      },

      huifangFormRefRules: {
        huifang_title: [
          { required: true, message: '请输入回访标题', trigger: 'blur' },
          { min: 1, max: 1000, message: '必须1位字符 ', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getyunyingList()
    // this.yuangongList() 
     
    this.userPhone = window.sessionStorage.getItem('qiye_mob')
        // this.copyright = window.sessionStorage.getItem('copyright')
    this.qiyeName = window.sessionStorage.getItem('qiye_name')
  },
  mouted() {
    
  },
  methods: {
    printPage() {
      // 创建一个新窗口
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        // 设置页面HTML
        printWindow.document.write('<html><head><title>打印页面</title>');
        printWindow.document.write('<style> *{font-size: 14px}</style>');
        printWindow.document.write('</head><body>');
        const styleNode = printWindow.document.createElement('style')
        styleNode.innerHTML = `
                .shigongdan {
                        widows: 1000px;
                        height: 200px;
                      padding: 5px;
                      font-size:13px;
                      }

                      .shigongdan_hang01 {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-around;
                      }

                      .xiangmu01 {
                        width: 300px;
                        text-align: left;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-around;
                      }

                      .data01 {
                        width: 200px;
                        text-align: left;
                      }

                      .name01 {
                        text-align: left;
                        width: 80px;
                        height: 35px;
                      }
                      .xian{
                        background-color: black; height: 5px;
                      }
                      .data02{
                        width:200px;
                      }
                      .title{
                              font-size: 20px;
                              text-align: center;
                              margin-bottom: 3px;
                            }
                      `
        printWindow.document.head.appendChild(styleNode)
        printWindow.document.write(document.querySelector('#printMe').innerHTML);
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // 关闭文档
        printWindow.focus(); // 聚焦新窗口
        // 打印内容
        printWindow.print();
        // 关闭新窗口
        printWindow.close();
      }
    },

    handleExport() {
      exportExcel('report', '导出.xlsx')
    },
    get_switch_value(switchValue) {
      this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
      console.log(this.huifangForm.huifang_genjin);
    },
    async huiFangAdd() {
      const { data: res } = await this.$http.post('api', this.huifangForm);
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.huifangDialogVisible = true;
    },
    async get_yunying_add() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 3 }
      });
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.addForm.yunying_bianhao = JSON.parse(res.data)[0].bianhao_s;
      // this.total = JSON.parse(res.data)[0].total
      this.addDialogVisible = true;
    },

    async getyunyingList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      // console.log(JSON.parse(res.data))
      this.yunyingList = JSON.parse(res.data)[0].dataList;
      console.log(this.yunyingList)
      if (!this.yunyingList) return;
      this.yunyingList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total)
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getyunyingList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getyunyingList();
    },

    async addyunying() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        const { data: res } = await this.$http.post('api', this.addForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 201) {
          this.$message.error('手机号码重复')
          return
        } else if ((JSON.parse(res.data)[0].status !== 200) && (JSON.parse(res.data)[0].status !== 201)) {
          this.$message.error('添加失败')
          return
        }
        this.$message.success('添加成功');
        this.getyunyingList();
        this.addDialogVisible = false;
      });
    },
    async addHuifang() {
      this.$refs.huifangFormRef.validate(async valid => {
        if (!valid) return 1;
        this.huifang_isDisable = true
        setTimeout(() => {
          this.huifang_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)

        const { data: res } = await this.$http.post('api', this.huifangForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        this.$message.success('添加成功');
        this.getyunyingList();
        this.huifangDialogVisible = false;
      });
    },
    async yuangongList() {
      const { data: res } = await this.$http.get('get_api', {
        params: {
          C_type: 'yuangong_list'
        }
      });
      this.yuangong_options = JSON.parse(res.data)[0].dataList
      console.log(999, this.yuangong_options)
    },
    async showZhijianDialog(uid) {
      this.zhijianDialogVisible = true
      this.editFormZhijian.yunying_uid = uid
      // this.yuangongList()
      // 质检信息在tbl_yunying中,位于同一张表
    },
    async showShigongdanDialog(index) {
      this.shigongdanDialogVisible = true
      this.yunyingInfoNow = this.yunyingList[index]
      console.log(this.yunyingInfoNow)
      // this.editFormShigongdan.yunying_uid = uid
      // this.yuangongList()
      // 质检信息在tbl_yunying中,位于同一张表
    },
    async showFenpeiDialog(uid) {
      this.editDialogVisible = true
      this.editFormYuangong.yunying_uid = uid
      this.yuangongList()
    },
    async updateyunying() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return this.$message.error('验证错误！');
        // 对象加入一个项C_type
        const { data: res } = await this.$http.post('api', this.editFormYuangong);
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败');
          return;
        }
        this.$message.success('更新成功');
        this.getyunyingList();
        this.editDialogVisible = false;
      });
    },
    async updateZhijian() {
      // 对象加入一个项C_type
      const { data: res } = await this.$http.post('api', this.editFormZhijian);
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('更新失败');
        return;
      }
      this.$message.success('更新成功');
      this.getyunyingList();
      this.zhijianDialogVisible = false;
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    huifangDoalogClosed() {
      this.$refs.huifangFormRef.resetFields();
    },
    showHuifangDialog(uid) {
      this.huifangDialogVisible = true;
      this.yunyingInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    shigongDoalogClosed() {

    },
    async yunyingInfo(uid) {

    },
    // 删除一条记录
    async deleteForm(yunyingUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'yunying_del',
        C_data1: yunyingUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.getyunyingList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
  background-color: #f2f6fc;
}

.el_row_two {
  margin-top: 30px;
}

.button_pz {
  width: 130px;
  height: 40px;
}

el-pagination {
  bottom: unset;
}

.shigongdan {
  widows: 1000px;
  height: 200px;
  // border: 1px black solid;
  padding: 5px;
}

.shigongdan_hang01 {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.xiangmu01 {
  width: 300px;
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.data01 {
  width: 200px;
  text-align: left;
}

.name01 {
  text-align: left;
  width: 120px;
  height: 35px;
}

.title {
  font-size: 20px;
  text-align: center;
  margin-bottom: 3px;
}

/* 打印时的样式 */
@media print {
  .print-only {
    display: block;
    /* 在打印时显示 */
  }

  /* 可以隐藏不需要打印的元素 */
  .no-print {
    display: none;
    /* 在打印时隐藏 */
  }
}
</style>
